import { render, staticRenderFns } from "./ioRecord.vue?vue&type=template&id=ac98e20a&scoped=true"
import script from "./ioRecord.vue?vue&type=script&lang=js"
export * from "./ioRecord.vue?vue&type=script&lang=js"
import style0 from "./ioRecord.vue?vue&type=style&index=0&id=ac98e20a&prod&scoped=true&lang=css"
import style1 from "./ioRecord.vue?vue&type=style&index=1&id=ac98e20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac98e20a",
  null
  
)

export default component.exports